import type { TFunction } from 'i18next'

import { getApiErrorMessage } from 'shared/lib/errorText'

export const getBookingErrorMessage = (
  error: unknown,
  t: TFunction<'translation', undefined>,
): string => {
  const fallbackMessage = t('kyrgyzstan_block.booking.errors.common')

  return getApiErrorMessage(error, fallbackMessage) || fallbackMessage
}
